export default __webpack_public_path__ + "static/media/icon_app.31c55b52.svg";